import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { buildPlanRecommendationRequestBody } from './build-plan-recommendation-request-body';
const PLAN_RECOMMENDATION_FALLBACK = {
  bullets: ['premium-purchase-plan.eclipse.ai-recommendation.fallback-bullet-1', 'premium-purchase-plan.eclipse.ai-recommendation.fallback-bullet-2', 'premium-purchase-plan.eclipse.ai-recommendation.fallback-bullet-3'],
  isFallback: true
};
export const getPlanRecommendationQueryFn = async props => {
  const {
    httpClient,
    request: {
      siteGuid,
      p3Context
    }
  } = props;
  const {
    getProductCardList
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const catalog = await getProductCardList(p3Context);
  const body = buildPlanRecommendationRequestBody(catalog, siteGuid);
  if (!body) {
    throw new Error('No recommendable product to request a plan recommendation');
  }
  try {
    const response = await httpClient.post('/_api/premium-package-pickers-api/get-plan-recommendation', body);
    return response.data;
  } catch {
    return {
      ...PLAN_RECOMMENDATION_FALLBACK,
      siteName: '',
      recommendedProductId: body.recommendedProductIdFallback,
      recommendedProductName: body.recommendedProductNameFallback
    };
  }
};
//# sourceMappingURL=get-plan-recommendation.query.js.map